import { useAuth, useOverview } from "./../hooks";
import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const isAuthenticated = () => {
  return sessionStorage.getItem("accessToken") !== null;
};

export const PersistRoute = () => {
  const { useGlobalAccount } = useOverview();
  const { data: globalData } = useGlobalAccount(isAuthenticated());

  const navigate = useNavigate();
  const { setStateVariable } = useAuth();

  // reset scroll position when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (globalData?.data) {
      const resp = globalData;

      if (
        resp?.data?.user?.status === "APPROVED" &&
        resp?.data?.user?.currentStep === "ACTIVE"
      ) {
        navigate("/home", { replace: true });
        return;
      }

      if (resp?.data?.user?.currentStep === "REGISTER") {
        setStateVariable(1);
        navigate("/details", { replace: true });
        return;
      }

      if (resp?.data?.user?.currentStep === "PERSONAL_INFO") {
        setStateVariable(2);
        navigate("/details", { replace: true });
        return;
      }

      if (resp?.data?.user?.currentStep === "SIGNUP") {
        setStateVariable(3);
        navigate("/details", { replace: true });
        return;
      }

      if (resp?.data?.user?.currentStep === "DOC_UPLOAD") {
        setStateVariable(5);
        navigate("/details", { replace: true });
        return;
      }

      if (resp?.data?.user?.currentStep === "SELFIEE_UPLOAD") {
        navigate("/redirect?status=success", { replace: true });
        return;
      }
      if (
        resp?.data?.user?.currentStep === "SUBMIT" ||
        resp?.data?.user?.currentStep === "SUBMITTED"
      ) {
        navigate("/homeVerification", { replace: true });
      }
    }
  }, [globalData, navigate]);

  // Render child routes if authenticated
  return <Outlet />;
};
